import { HttpClient } from '@/data/protocols/http'
import { RemoteAccountChangeLanguage } from '@/data/usecases/account/remote-account-change-language'
import { AccountChangeLanguage } from '@/domain/usecases/account/account-change-language'
import { GenericResponse } from '@/infra/http'
import { makeApiV2Url, makeHttpAuthClient } from '@/main/factories/http'

export const makeRemoteAccountChangeLanguage = (): AccountChangeLanguage => {
  return new RemoteAccountChangeLanguage(
    makeApiV2Url('/user/account/language'),
    makeHttpAuthClient() as HttpClient<GenericResponse<RemoteAccountChangeLanguage.Model>>
  )
}
